import React, { useState, useEffect } from 'react';
import styles from '../styles/affordableGear.module.scss';
import AdSenseBlock from "../components/AdSenseBlock";
import { AD_SLOTS } from "../constants/adSlots";
import { Helmet } from "react-helmet";
import { createRakutenLink } from "../utils/rakuten";
import { createAmazonLink } from '../utils/amazon'; 

const AffordableGear = () => {

  // ▼ ギアカードを配列化（ここにどんどん追加できる）
  const gearItems = [
    {
      category: "ザック",
      title: "SALOMON ADV SKIN シリーズ",
      link: "SALOMON ADV SKIN シリーズ",
      desc: "生地がやわらかく、長時間背負っても肩が痛くなりにくい。5L/12Lの容量が選べて初心者にも最適。ウィメンズモデルは専用設計。"
    },
    {
      category: "ザック",
      title: "PAAGOWORKS RUSH シリーズ",
      link: "PAAGOWORKS RUSH7 RUSH11 RUSH20 トレラン",
      desc: "日本ブランドならではの、日本人に合った設計。フィット感と使いやすさが抜群で、フォルムも美しい。"
    },
    {
      category: "シューズ",
      title: "Altra トレイルランニングシューズ",
      link: "Altra トレイルランニング シューズ",
      desc: "足幅広めで履きやすく、長時間でも快適。履き続けるうちに足が自然とこの形に馴染んでくるようで、気づけばこれ以外が履けなくなる。"
    },
    {
      category: "シューズ",
      title: "asics トレイルランニングシューズ",
      link: "asics トレイルランニング シューズ",
      desc: "日本人の足に合うフィット感。コスパも優秀。"
    },
    {
      category: "ソックス",
      title: "インナーファクト ラミーソックス",
      link: "インナーファクト ラミーソックス",
      desc: "ラミー素材は天然繊維の中でも特に強度が高い素材らしい。履き心地も快適で、汗をかいてもベタつかない。"
    },
    {
      category: "ソックス",
      title: "injinji  インジンジ トレイル ミッドウェイト",
      link: "injinji  インジンジ トレイル ミッドウェイト",
      desc: "五本指でもとっても履きやすい。弱めですがアーチサポートもあり。"
    },
    {
      category: "時計",
      title: "Garmin GPSウォッチ",
      link: "Garmin  Enduro fenix Forerunner",
      desc: "ナビゲーションがとにかく優秀。レースコースを時計に入れておけば、山の中でも安心。レース中の高低把握機能も秀逸。"
    },
    {
      category: "ヘッドライト",
      title: "レッドレンザー H8R",
      link: "h8r レッドレンザー",
      desc: "伝説の名作。全体的にモデルチェンジしているが、最近復活。明るいのに、バッテリーが長持ち。長距離レースでも安心。"
    },
    {
      category: "ヘッドライト",
      title: "マイルストーン MS-i1",
      link: "MS-i1 マイルストーン",
      desc: "白と電球のミックス光により足元の凹凸が立体的に見えやすい。ウエストベルトに付ける、PAAGOWORKSとのコラボモデルある。"
    },
    {
      category: "ヘッドライト",
      title: "ペツル スイフト LT",
      link: "ペツル スイフト LT",
      desc: "軽量（43 g）で手のひらに収まるコンパクトなヘッドランプ。かさばらない、重さも気にならないので、必携装備の予備ランプに最適。"
    },
    {
      category: "レインウェア",
      title: "ノースフェイス ストライクトレイルジャケット",
      link: "ノースフェイス ストライクトレイルジャケット",
      desc: " 軽量・コンパクトなわりに、丈夫。透湿性能も高いので、雨の日も快適に走れる。"
    },
    {
      category: "トレランポール",
      title: "シナノ トレランポール",
      link: "シナノ トレランポール",
      desc: "使えるレースは限られるが、ポールがあると脚の負担が大きく軽減される。シナノ人口多い気がする。"
    },

    // ★ この先どんどん追加してOK
  ];

  // ▼ 最初は 6 件だけ表示
  const [visibleCount, setVisibleCount] = useState(6);

  const handleLoadMore = () => {
    setVisibleCount(prev => prev + 6);
  };

const [isMobile, setIsMobile] = useState(false);

useEffect(() => {
  const handleResize = () => {
    setIsMobile(window.innerWidth < 480);
  };

  handleResize(); // 初回実行
  window.addEventListener('resize', handleResize);

  return () => window.removeEventListener('resize', handleResize);
}, []);

  return (
    <>
      <Helmet>
        <title>初心者向けトレランギア特集｜コスパ重視で選ぶおすすめ装備</title>
        <meta
          name="description"
          content="初心者で安心して選べる、コスパ重視のトレランギアを厳選紹介。ザック・シューズ・ソックス・GPSウォッチなど、実用性と価格のバランスに優れたおすすめ装備を紹介します。"
        />
        <meta
          name="keywords"
          content="トレラン, トレイルランニング, 初心者, ギア, 装備, コスパ, GPSウォッチ, ソックス, ザック, シューズ"
        />
      </Helmet>

      <main style={{ maxWidth: '820px', margin: '0 auto', padding: '1rem' }}>
        {/* ヒーローセクション */}
        <section
          className={styles.hero}
          style={{
            background: 'rgba(255,255,255,0.55)',
            padding: '1.4rem',
            borderRadius: '12px',
            marginBottom: '1.6rem',
            maxWidth: '820px',
            margin: '0 auto 1.6rem',
            textAlign: 'left'
          }}
        >
          <h1 style={{ marginBottom: '1rem' }}>
            トレランギア特集｜軽量・コンパクトで丈夫な実用装備
          </h1>

          <p style={{ color: '#444', lineHeight: 1.75 }}>
            初心者でも扱いやすい、軽量・コンパクトでありながら丈夫さも備えたギアを厳選しました。<br />
            持ち運びやすさ、使いやすさ、そして山の環境に耐えられる信頼性を基準にセレクトしています。<br />
            自分の体験から得たこだわりポイントも加え、迷わず選べるラインナップにしました。<br />
            「軽い装備で始めたい」「長く使える丈夫なギアが欲しい」そんな方にぴったりです。
          </p>
        </section>
        <AdSenseBlock adSlot={AD_SLOTS.AFFORDABLE_TOP} />

        {/* ギアカテゴリ別紹介 */}
        <section 
          className={styles.gearList} 
          style={{ 
            paddingLeft: 0,
            paddingRight: 0,
            marginLeft: 0,
            marginRight: 0,
            width: '100%',
            maxWidth: '100%',
          }}
        >
          <h2 style={{ marginTop: '2rem' }}>カテゴリ別おすすめトレランギア</h2>
          <div
            style={{
              display: 'grid',
              gridTemplateColumns: isMobile
                ? '1fr'
                : 'repeat(auto-fit, minmax(300px, 1fr))',
              gap: '1.4rem',
              marginTop: '1.6rem',
              width: '100%',
            }}
          >

          {gearItems.slice(0, visibleCount).map((item, index) => (
            <div
              key={index}
              style={{
                padding: '1.2rem',
                background: 'rgba(255,255,255,0.75)',
                borderRadius: '14px',
                boxShadow: '0 4px 14px rgba(0,0,0,0.08)',
                transition: 'transform 0.2s ease, boxShadow 0.2s ease'
              }}
              onMouseEnter={e => {
                e.currentTarget.style.transform = 'translateY(-4px)';
                e.currentTarget.style.boxShadow = '0 10px 28px rgba(0,0,0,0.12)';
              }}
              onMouseLeave={e => {
                e.currentTarget.style.transform = 'translateY(0px)';
                e.currentTarget.style.boxShadow = '0 4px 14px rgba(0,0,0,0.08)';
              }}
            >
              <h3 style={{ marginBottom: '0.4rem' }}>{item.category}</h3>

              {/* タイトル（リンクなしに変更） */}
              <div style={{ fontWeight: 600, marginBottom: '0.4rem', color: '#333' }}>
                {item.title}
              </div>

              <p style={{ marginTop: '0.5rem', color: '#555' }}>
                {item.desc}
              </p>

              {/* ▼ 楽天 / Amazon ボタン */}
              <div style={{ display: 'flex', gap: '0.6rem', marginTop: '0.8rem' }}>
                <a
                  href={createRakutenLink(item.link)}
                  target="_blank"
                  rel="nofollow noopener"
                  style={{
                    padding: '0.4rem 0.8rem',
                    background: '#f2f2f7',
                    borderRadius: '8px',
                    color: '#bf0000',
                    fontWeight: 600,
                    textDecoration: 'none',
                    fontSize: '0.9rem',
                    flex: 1,
                    textAlign: 'center'
                  }}
                >
                  楽天で見る
                </a>

                <a
                  href={createAmazonLink(item.link)}
                  target="_blank"
                  rel="nofollow noopener"
                  style={{
                    padding: '0.4rem 0.8rem',
                    background: '#f2f2f7',
                    borderRadius: '8px',
                    color: '#ff9900',
                    fontWeight: 600,
                    textDecoration: 'none',
                    fontSize: '0.9rem',
                    flex: 1,
                    textAlign: 'center'
                  }}
                >
                  Amazonで見る
                </a>
              </div>
            </div>
          ))}

          </div>

          {/* もっと見るボタン */}
          {visibleCount < gearItems.length && (
            <div style={{ textAlign: 'center', marginTop: '1.6rem' }}>
              <button
                onClick={handleLoadMore}
                style={{
                  margin: "28px auto 0",
                  display: "block",
                  padding: "10px 0",
                  background: "transparent",
                  border: "none",
                  color: "#2c7be5",
                  fontSize: "1.5rem",
                  fontWeight: 600,
                  letterSpacing: "0.02em",
                  cursor: "pointer",
                  textAlign: "center",
                  transition: "all 0.25s ease",
                  opacity: 0.85
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.opacity = "1";
                  e.currentTarget.style.transform = "translateY(-2px)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.opacity = "0.85";
                  e.currentTarget.style.transform = "translateY(0)";
                }}
              >
                続きを見る ↓
              </button>
            </div>
          )}
        </section>

        {/* CTA */}
        <section className={styles.cta}
          style={{
            background: 'rgba(255,255,255,0.55)',
            padding: '1rem',
            borderRadius: '12px',
            marginTop: '2rem'
          }}
        >
          <h2>今すぐチェック</h2>
          <p>まずは気になるギアを見てみましょう。レビューや価格比較も参考に！</p>

          <div style={{
            display: 'flex',
            gap: '0.8rem',
            justifyContent: 'center',
            marginTop: '1rem',
            flexWrap:'wrap'
          }}>
            {/* 楽天 */}
            <a
              href={createRakutenLink("トレイルランニング ギア")}
              target="_blank"
              rel="nofollow noopener"
              style={{
                padding: '0.5rem 0.8rem',
                background: '#f2f2f7',
                borderRadius: '8px',
                color: '#bf0000',
                fontWeight: 600,
                textDecoration: 'none',
                fontSize: '0.9rem',
                flex: 1,
                textAlign: 'center'
              }}
            >
              楽天でギアを見る
            </a>

            {/* Amazon */}
            <a
              href={createAmazonLink("パーゴワークス rush")}
              target="_blank"
              rel="nofollow noopener"
              style={{
                padding: '0.5rem 0.8rem',
                background: '#f2f2f7',
                borderRadius: '8px',
                color: '#ff9900',
                fontWeight: 600,
                textDecoration: 'none',
                fontSize: '1rem',
                flex: 1,
                textAlign: 'center'
              }}
            >
              Amazonでギアを見る
            </a>
          </div>
        </section>

      </main>
    </>
  );
};

export default AffordableGear;
